import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import styles from './DeleteAccountModal.module.css';

const DeleteAccountModal = ({ onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={styles.modalOverlay}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className={styles.modalContent}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className={styles.buttonContainer}>
          <button onClick={onClose} className={styles.nevermindButton}>
            {t('nevermind')}
          </button>
        </div>

        <p className={styles.modalText}>
          {t('delete_account_warning')}
        </p>

        <div className={styles.deleteButtonContainer}>
          <p className={styles.deleteAccountText}>
            <button onClick={onConfirm} className={styles.deleteAccountButton}>
              {t('click_here')}
            </button>{' '}
            {t('confirm_account_deletion')}
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default DeleteAccountModal;
